import { render } from "./DetailsPictures.vue?vue&type=template&id=f11fcfbe"
import script from "./DetailsPictures.vue?vue&type=script&lang=js"
export * from "./DetailsPictures.vue?vue&type=script&lang=js"

import "./DetailsPictures.vue?vue&type=style&index=0&id=f11fcfbe&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__